import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Collapsible from 'react-collapsible';
import NameFormat from '../../nameFormat/NameFormat';
import Surname from '../../surname/Surname';
import GivenName from '../../quotationCVComponent/givenName/GivenName';
import MaritalStatus from '../../maritalStatus/MaritalStatus';
import Sex from '../../sex/Sex';
import AgeRange from '../ageRange/AgeRange';
import DrivingExperience from '../../drivingExperience/DrivingExperience';
import NoOfClaimsInPast3Years from '../../noOfClaimsInPast3Years/NoOfClaimsInPast3Years';
import TotalClaimAmountInPast3Years from '../../totalClaimAmountInPast3Years/TotalClaimAmountInPast3Years';
import Occupation from '../occupation/Occupation';
import Nationality from '../../quotationCVComponent/nationality/Nationality';
import DriverInfo from '../../quotationCVComponent/driverInfo/DriverInfo';
import ParticularOfAdditionalDriver from '../../quotationCVComponent/particularOfAdditionalDriver/ParticularOfAdditionalDriver';

class ParticularOfMainDriver extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      open: false,
      nameFormatRequired: false,
      surnameRequired: false,
      drivingExperienceRequired: false,
      noOfClaimsRequired: false,
      totalClaimAmountRequired: false,
      sexRequired: false
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
          <h3 className="ebaoUtil__HeaderThree">
            <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ open: !this.state.open })}>
              {this.state.open ? 'Particular Of Main Driver ▲ ' : 'Particular Of Main Driver ▼'}
            </a>
          </h3>

          <Collapsible open={this.state.open}>
          <FormGroup>
            <Col sm={6}>
              <DriverInfo
                driverInfo={this.props.particularOfMainDriver.isDriverInfo}
                handleChangeDriverInfo={this.props.handleChangeParticularOfMainDriver}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>

          <FormGroup controlId="nameFormat">
            <Col sm={6}>
              <NameFormat
                nameFormat={this.props.particularOfMainDriver.nameFormat}
                handleChangeNameFormat={this.props.handleChangeParticularOfMainDriver}
                required={this.state.nameFormatRequired}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="surnameGivenName">
            <Col sm={6}>
              <Surname
                surname={this.props.particularOfMainDriver.surname}
                handleChangeSurname={this.props.handleChangeParticularOfMainDriver}
                required={this.state.surnameRequired}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <GivenName
                givenName={this.props.particularOfMainDriver.givenName}
                handleChangeGivenName={this.props.handleChangeParticularOfMainDriver}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="drivingExperienceAgeRange">
            <Col sm={6}>
              <DrivingExperience
                drivingExperience={this.props.particularOfMainDriver.drivingExperience}
                handleChangeDrivingExperience={this.props.handleChangeParticularOfMainDriver}
                required={this.state.drivingExperienceRequired}
                validation={this.props.validation}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <AgeRange
                handleChangeAgeRange={this.props.handleChangeParticularOfMainDriver}
                calculation={this.props.calculation}
                ageRange={this.props.particularOfMainDriver.ageRange}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="maritalStatusSex">
            <Col sm={6}>
              <MaritalStatus
                handleChangeMaritalStatus={this.props.handleChangeParticularOfMainDriver}
                maritalStatus={this.props.particularOfMainDriver.maritalStatus}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <Sex
                sex={this.props.particularOfMainDriver.sex}
                handleChangeSex={this.props.handleChangeParticularOfMainDriver}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
                required={this.state.sexRequired}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="noOfClaimInPast3YearTotalClaimAmountInPast3Years">
            <Col sm={6}>
              <NoOfClaimsInPast3Years
                noOfClaimsInPast3Years={this.props.particularOfMainDriver.noOfClaimsInPast3Years}
                handleChangeNoOfClaimsInPast3Years={this.props.handleChangeParticularOfMainDriver}
                required={this.state.noOfClaimsRequired}
                validation={this.props.validation}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <TotalClaimAmountInPast3Years
                totalClaimAmountInPast3Years={this.props.particularOfMainDriver.totalClaimAmountInPast3Years}
                handleChangeTotalClaimAmountInPast3Years={this.props.handleChangeParticularOfMainDriver}
                required={this.state.totalClaimAmountRequired}
                validation={this.props.validation}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="occupationNationality">
            <Col sm={6}>
              <Occupation
                occupation={this.props.particularOfMainDriver.occupation}
                handleChangeOccupation={this.props.handleChangeParticularOfMainDriver}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <Nationality
                nationality={this.props.particularOfMainDriver.nationality}
                handleChangeNationality={this.props.handleChangeParticularOfMainDriver}
                disabled={!this.props.particularOfMainDriver.isDriverInfo}
              />
            </Col>
          </FormGroup>
          {Array(this.props.count)
              .fill(1)
              .map((el, index) => {
                const counter = index
                const additionalDriveTitle = `Particular of Additional Driver ${counter + 1}`;
                const tmp = this.props.particularOfAdditionalDriver[counter];
                return <ParticularOfAdditionalDriver
                  key={counter}
                  title={additionalDriveTitle}
                  particularOfAdditionalDriver={tmp}
                  handleChangeParticularOfAdditionalDriver={this.props.handleChangeParticularOfAdditionalDriver}
                  calculation={this.props.calculation}
                  validation={this.props.validation}
                />
              })
          }
          <div className="ebaoUtil_Float-Right">
            {this.props.count < 3 && this.props.isValidCreateDriver ?
              <button className="btn btn-axa" onClick={this.props.createDriver} >Add Addtional Driver</button> :
              <button className="btn btn-axa" onClick={this.props.createDriver} disabled>Add Additional Driver</button>
            }
            {' '}
            {this.props.count <= 0 ?
              <button className="btn btn-axa" onClick={this.props.removeDriver} disabled >Remove</button> :
              <button className="btn btn-axa" onClick={this.props.removeDriver} >Remove</button>
            }
          </div>
          </Collapsible>
      </div>
    )
  }
}

ParticularOfMainDriver.propTypes = {
  particularOfMainDriver: PropTypes.object,
  particularOfAdditionalDriver: PropTypes.array,
  handleChangeParticularOfMainDriver: PropTypes.func,
  handleChangeParticularOfAdditionalDriver: PropTypes.func,
  calculation: PropTypes.func,
  count: PropTypes.number,
  createDriver: PropTypes.func,
  removeDriver: PropTypes.func,
  isValidCreateDriver: PropTypes.bool,
  validation: PropTypes.func
};

export default ParticularOfMainDriver;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/particularOfMainDriver/ParticularOfMainDriver.js